export const DeleteLocalImage = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect opacity="0.6" width="24" height="24" rx="4" fill="black" />
    <path
      d="M8.66663 18C8.29996 18 7.98607 17.8694 7.72496 17.6083C7.46385 17.3472 7.33329 17.0333 7.33329 16.6667V8H6.66663V6.66667H9.99996V6H14V6.66667H17.3333V8H16.6666V16.6667C16.6666 17.0333 16.5361 17.3472 16.275 17.6083C16.0138 17.8694 15.7 18 15.3333 18H8.66663ZM9.99996 15.3333H11.3333V9.33333H9.99996V15.3333ZM12.6666 15.3333H14V9.33333H12.6666V15.3333Z"
      fill="#E8EAED"
    />
  </svg>
);
